// extracted by mini-css-extract-plugin
module.exports = {"titleMargins":"e_Jg","categoriesGrid":"e_Kg","slotsContent":"e_Lg","hero":"e_Mg","listTitle":"e_Ng","list":"e_Og","sidebar":"e_Pg","leaderboard":"e_Qg","secondHero":"e_Rg"};